import { useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { useMount } from 'react-use'
import { objectKeys } from 'ts-extras'

import { IfaDetailsFormValues } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/IfaDetailsForm/IfaDetailsForm'
import { IFA_DETAILS_FORM_FIELDS } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/constants'
import useAppDispatch from '@/hooks/useAppDispatch'
import { useCurrentCompanyServicesQuery } from '@/hooks/useCompanyServicesQuery'
import { markFieldsAsTouched } from '@/lib/helpers/helperFunctions'
import { setIsCompanyServicesValid } from '@/redux/slices/completeRegistrationPopup'

const ValidationTracker: React.FC = () => {
  const { isValid: isFormValid, setFieldTouched } =
    useFormikContext<IfaDetailsFormValues>()
  const dispatch = useAppDispatch()

  const companyServicesQuery = useCurrentCompanyServicesQuery()

  const companyServices = companyServicesQuery.data?.['hydra:member']
  const hasServices = !!companyServices && companyServices.length > 0
  const isValid = hasServices && isFormValid

  useMount(() => {
    markFieldsAsTouched(objectKeys(IFA_DETAILS_FORM_FIELDS), setFieldTouched)
  })

  useEffect(() => {
    dispatch(setIsCompanyServicesValid(isValid))
  }, [dispatch, isValid])

  return null
}

export default ValidationTracker
